import { useLogo, type UseLogoProps } from "./use-logo";
import LogoSvg from "./logo-svg";

export type LogoProps = UseLogoProps;

function Logo(props: LogoProps) {
  const { styles } = useLogo(props);

  return <LogoSvg iconColor={styles.icon()} textColor={styles.name()} />;
}

export default Logo;
